<div *ngIf="pdfSrc" class="h-100">
    <iframe  [src]="pdfSrc | safe" width="100%" height="100%" ></iframe>
</div>
